import { GzRmTopIdentitiesRiskWidgetWebComponent } from './component/GzRmTopIdentitiesRiskWidgetWebComponent';

export { GzRmTopIdentitiesRiskWidgetWebComponent };
